import moment from "moment";

import { DATE_TIME, DATE_TIME_FORMAT } from "../../config";

export const dateSetEndOfTheDate = (value) => {
    const date = new Date(value);

    return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23,
        59,
        59
    );
};

export const dateSetZeroTimeOfTheDate = (value) => {
    const date = new Date(value);

    return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        0,
        0,
        0
    );
};


export const getTimeDifferenceInSeconds = (start, end) => {
    if(!start || !end){
        return null;
    }

    let startDate = new Date(start);
    let endDate   = new Date(end);
    return  startDate && endDate ? ((endDate.getTime() - startDate.getTime()) / 1000) : null;
};

export const  millisToMinutesAndSeconds = (millis) => {
    let seconds = Math.floor((millis / 1000) % 60);
    let minutes = Math.floor((millis / (1000 * 60)) % 60);
    let hours = Math.floor((millis / (1000 * 60 * 60)) % 24);

    if(!seconds && !minutes && !hours){
        return null;
    }

    return `${hours ? `${hours}h` : ""} ${minutes ? `${minutes}m` : ""} ${seconds < 10 ? "0" : ""}${seconds}s`;
};

export const timeDifferenceAndFormat = (start, end) => {
    const seconds = getTimeDifferenceInSeconds(start, end);

    return millisToMinutesAndSeconds(seconds * 1000);
};

//"30 Oct 2025 18:30:00" => "2025-10-30 18:30:00"
export const convertDateToFormat = (input) => {
    const date = new Date(input + " UTC");

    const pad = (num) => String(num).padStart(2, "0");

    return `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())} ` +
        `${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())}`;
};

export const secondsToTimeSpan = (seconds) => (
    moment.utc(seconds * 1000).format(DATE_TIME_FORMAT)
);

export const getDate = (date) => (
    date ? moment(date).format() : null
);

export const getDateFromData = (date, format = DATE_TIME_FORMAT) => (
    date ? moment(date).format(format || DATE_TIME) : null
);

export const fromDataToUtcTimeZone = (date, format = DATE_TIME_FORMAT, utcFormat = false) => (
    date ? moment(date).utc(utcFormat).format(format || DATE_TIME) : null
);
